
import "./AllClients.css";
import React, { useState, useEffect } from "react";
import { allClients } from "../../api";
import { radioType } from "../../interfaces";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import chunk from "chunk";
import Header from "../../Components/Header/Header";
import AllClientsTable from "./AllClientsTable";
import DeleteClient from "./DeleteClient";
import ReasonForCancel from "./ReasonForCancel";
import Cancelation from "./Cancelation";
import Loading from "../../Components/Loading/Loading";

function AllClients() {

    const {
        openDelete,
        setOpenDelete,
        concretClient,
        setConcretClient,
        findRole,
        setLoading,
        clients,
        setClients
    } = useGlobalContext()

    const [searchBarInpValue, setSearchBarInpValue] = useState<string>("");
    const [searchBtn, setSearchBtn] = useState<boolean>(false);
    const [showClients, setShowClients] = useState<Array<any>>([]);
    const [showChunk, setShowChunk] = useState<Array<any>>([]);
    const [activePage, setActivePage] = useState<number>(1);
    const [openCansel, setOpenCansel] = useState<boolean>(false);
    const [openReason, setOpenReason] = useState<boolean>(false);
    const [reasonsType, setReasonsType] = useState<radioType[]>([
        {
            id: 1,
            title: "Family Emergency",
            active: true,
        },
        {
            id: 2,
            title: "Out of the Country",
            active:false,
        },
        {
            id: 3,
            title: "Out of Business",
            active:false,
        },
        {
            id: 4,
            title: "No Funds",
            active:false,
        },
        {
            id: 5,
            title: "Content",
            active: true,
        },
        {
            id: 6,
            title: "Our Mistake (Wrong Info)",
            active:false,
        },
        {
            id: 7,
            title: "Our Mistake (Grammar Issues)",
            active:false,
        },
        {
            id: 8,
            title: "Business change",
            active:false,
        },
        {
            id: 9,
            title: "Brokerage Has Our Service",
            active: true,
        },
        {
            id: 10,
            title: "Requests Being Late",
            active:false,
        },
        {
            id: 11,
            title: "No Answer to our Calls/Emails",
            active:false,
        },
        {
            id: 12,
            title: "Ad Campaign",
            active:false,
        },
        {
            id: 13,
            title: "Charges disputed",
            active: false,
        },
        {
            id: 14,
            title: 'Dissatisfaction with the quality of service',
            active: false
        },
        {
            id: 15,
            title: 'No Payment or Response (Trial)',
            active: false
        },
        {
            id: 16,
            title: 'No Payment or Response (Not Trial)',
            active: false
        },
        {
            id: 17,
            title: 'Disputed',
            active: false
        },
        {
            id: 18,
            title: 'Issues with AM',
            active: false
        },
        {
            id: 19,
            title: 'No Results',
            active: false
        },
        {
            id: 21,
            title: 'Doesn\'t need our services',
            active: false
        },
        {
            id: 20,
            title: "Other",
            active: false,
        }
    ]);
    const [otherType, setOtherType] = useState('')
    const navigate = useNavigate();

    const gettingClients = async () => {
        setLoading(true);
        try {
            const getData = await allClients();
            setClients(getData.data.reverse());
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (clients.length === 0) gettingClients().then(r => r);
    }, []);

    useEffect(() => {
        setShowClients(clients);
    }, [clients])

    useEffect(() => {
        const chunkData = chunk(showClients, 20);
        setShowChunk(chunkData[activePage - 1]);
    }, [activePage, showClients])

    useEffect(() => {
        if (!searchBarInpValue) {
            setShowClients(clients);
            setActivePage(1);
        }
        else {
            setSearchBtn(true);
        }
    }, [searchBarInpValue])

    const handleCombinedSearch = (): void => {
        setShowClients(clients);
        setActivePage(1);
        if (searchBarInpValue) {
            setShowClients(showClients => showClients.filter(client => {
                const fullName = client.firstName.replaceAll(" ", "") + client.lastName.replaceAll(" ", "");
                const company = client.businessData.companyName?.replaceAll(" ", "");
                if (fullName.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase())) {
                    return fullName.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase());
                }
                else if (company?.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase())) {
                    return company?.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase());
                }
                else {
                    return false;
                }
            }))
        }
    }

    document.body.onkeydown = (e) => {
        if (e.key === "Enter" && searchBarInpValue) handleCombinedSearch();
    }

    const createClientBtn = (): void => {
        navigate("/create-client");
    }

    return (
        <div className = "allClients">
            <Header/>
            <div className = "allClients-container">
                <div className = "allClients-header">
                    <div className = "allClients-header-heading">
                        <h2>Clients</h2>
                    </div>
                    <div className = "allClients-header-btns">
                        {
                            (findRole("PX") === "ADMIN" || findRole("PX") === "MODERATOR") &&
                            <button
                                onClick = { createClientBtn }
                            >
                                Create a Client
                            </button>
                        }
                    </div>
                </div>
                <div className = "allClients-searchBar">
                    <div className = "allClients-searchBar-inp">
                        <span>Search by Client Name</span>
                        <input
                            type = "text"
                            value = { searchBarInpValue }
                            onChange = {(e) =>
                                setSearchBarInpValue(e.target.value)
                            }
                        />
                    </div>
                    <div className = "allClients-searchBar-btn">
                        <button
                            style = {{ cursor: searchBtn ? "pointer" : "not-allowed" }}
                            onClick = { handleCombinedSearch  }
                            disabled = { !searchBtn }
                        >
                            Search
                        </button>
                    </div>
                </div>
            </div>
            <AllClientsTable
                activePage = { activePage }
                setActivePage = { setActivePage }
                showClients = { showClients }
                setShowClients = { setShowClients }
                showChunk = { showChunk }
                setShowChunk = { setShowChunk }
                setConcretClient = { setConcretClient }
                setOpenDelete = { setOpenDelete }
                setOpenReason = { setOpenReason }
                setOpenCansel = { setOpenCansel }
            />
            {
                concretClient &&
                    <DeleteClient
                        openDelete = { openDelete }
                        setOpenDelete = { setOpenDelete }
                        concretClient = { concretClient }
                        setConcretClient = { setConcretClient }
                        gettingClients = { gettingClients }
                    />
            }
            {
                concretClient &&
                    <Cancelation
                        openCancel = { openCansel }
                        setOpenCancel = { setOpenCansel }
                        concretClient = { concretClient }
                        setConcretClient = { setConcretClient }
                        reasonsType = { reasonsType }
                        gettingClients = { gettingClients }
                        setActivePage = { setActivePage }
                        otherType = { otherType }
                        setOtherType = { setOtherType }
                    />
            }
            <ReasonForCancel
                openReason = { openReason }
                setOpenReason = { setOpenReason }
                reasonsType = { reasonsType }
                setReasonsType = { setReasonsType }
                setOpenCancel = { setOpenCansel }
                otherType = { otherType }
                setOtherType = { setOtherType }
            />
            <Loading/>
        </div>
    )
}

export default AllClients

